import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { InternalLink, SimpleFlexbox, FadeIn } from 'ctm-components';
import styles from './enter_details_manually.css';

class _EnterDetailsFooter extends PureComponent {

    /**
     * Set the dispatch for setting the disclaimer content expansion to false
     */
    setOnClickActions = () => {
        const { dispatch } = this.props;
        dispatch({
            type: 'SET_VALUE',
            identifier: 'helpers.isDisclaimerContentExpanded',
            value: false,
            stateKey: 'vertical.quote'
        });
    };

    /**
     * Render the component.
     * @returns {Node} - return the the Retrieve Quote Footer component
     */
    render = () => {
        return (
            <SimpleFlexbox className={styles.footer_link}>
                <FadeIn>
                    <span>If not - don't worry - </span>
                    <InternalLink variant="bold_underline" data-id="car_manual_lookup" onClick={this.setOnClickActions} href="/car-insurance/journey/car_make">
                        click here
                    </InternalLink>
                    <span> to enter the car details manually.</span>
                </FadeIn>
            </SimpleFlexbox>
        );
    };

}

_EnterDetailsFooter.propTypes = {
    dispatch: PropTypes.func
};

const EnterDetailsFooter = connect()(_EnterDetailsFooter);

export { _EnterDetailsFooter, EnterDetailsFooter };
